import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=6f5362c6&scoped=true&"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js&"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDialog.vue?vue&type=style&index=0&id=6f5362c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5362c6",
  null
  
)

component.options.__file = "WelcomeDialog.vue"
export default component.exports